import styled from 'styled-components'
import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import mapImg from '../../assets/map.png'
import NaverMapMobile from '../../components/NaverMapMobile'
function Page7Mobile(prop) {
  var settings = {
    dots: true,
    infinite: true,
    speed: 400,
    autoplay: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    appendDots: (dots) => (
      <div
        style={{
          height: '100px',
          display: 'flex',
          justifyContent: 'center',
          pointerEvents: 'none',
        }}
      >
        <ul
          style={{
            margin: '0',
            padding: '0',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          {dots}
        </ul>
      </div>
    ),
    customPaging: (i) => (
      <div
        style={{
          cursor: 'pointer',
          width: '8px',
          height: '8px',
          borderRadius: '8px',
          border: '0.7px solid #f7f7f7',
        }}
      ></div>
    ),
  }

  const { bannerList, socialList } = prop

  return (
    <MainContainer>
      <Text1>이건을 만날 수 있는 곳</Text1>
      <Text2>HOW TO CONTACT</Text2>
      <CustomSlider {...settings}>
        {bannerList &&
          bannerList.map((banner, idx) => {
            return (
              <Slide1 key={idx}>
                <Img
                  src={
                    process.env.REACT_APP_BASE_RESOURCES_API +
                    banner.baFileDto?.filePath
                  }
                ></Img>
              </Slide1>
            )
          })}
      </CustomSlider>
      <NaverMapMobile/>

      
      <ButtonsContainer>
            {socialList &&
              socialList.map((item, idx) => {
                return (
                  <Button
                    key={idx}
                    onClick={() => {
                      window.open(item.soLink, '_blank')
                    }}
                  >
                    <ButtonText1>{item.soTitle.toUpperCase()}</ButtonText1>
                    <ButtonText2>바로가기</ButtonText2>
                  </Button>
                )
              })}
          </ButtonsContainer>


          <BottomBottom>
            <BottomText1>이건하우스 본사 직영 전시장</BottomText1>
            <BottomText2>04001 서울시 마포구 동교로 161 (서교동)</BottomText2>
            <br />
            <BottomText2Area>
              <BottomB>대표번호</BottomB>
              <BottomText2>
                &nbsp; 1522-1271
              </BottomText2>
            </BottomText2Area>



            <BottomText2Area>
              <BottomB>운영시간</BottomB>
              <BottomText2>
                &nbsp; 평일 10:30 - 19:30
                <br />
                &nbsp; 토요일 10:00 - 17:00
                <br />
                &nbsp; 일요일 및 공휴일 휴관
                <br />
                &nbsp; 휴게시간 12:00 - 13:00
              </BottomText2>
            </BottomText2Area>

          </BottomBottom>

    </MainContainer>
  )
}

export default Page7Mobile
const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 66px;
  width: 100vw;
  overflow-x: hidden;
  padding-bottom: 60.7px;
`
const CustomSlider = styled(Slider)`
  width: calc(100vw - 50px);
  height: 445px;
  margin-left: 50px;
  overflow: hidden;
`
const Slide1 = styled.div`
  width: 100%;
  height: 445px;
  background: #a5a5a5;
`
const Img = styled.img`
  width: 100%;
  height: 445px;    
  object-fit: cover;
`

const Text1 = styled.p`
  font-family: Noto Sans KR;
  font-weight: normal;
  font-size: 21.7px;
  color: #000;
  margin-left: 50px;
  margin-top: 50px;
  letter-spacing: -0.6px;
`
const Text2 = styled.p`
  font-family: GMarketSans;
  font-weight: 500;
  font-size: 11.7px;
  color: #8e8e8e;
  margin-top: 5px;
  margin-left: 50px;
  letter-spacing: 0.3px;
  margin-bottom: 17px;
`
const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3vw;
  margin-top: 20px;
`
const Button = styled.div`
  width: 90%;
  margin: auto;
  height: 9vw;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  background: #b7a379;
  cursor: pointer;
`
const ButtonText1 = styled.p`
  font-family: GMarketSans;
  font-weight: 500;
  font-size: 4.3vw;
  color: #fff;
  margin-left: 1vw;
`
const ButtonText2 = styled.p`
  font-family: Noto Sans KR;
  font-weight: normal;
  font-size: 4vw;
  color: #fff;
  margin-right: 2vw;
`

const BottomText2Area = styled.div`
  display: flex;

`

const BottomBottom = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width:90%;
  margin-left:5%;
  margin-top: 6vw;
  margin-bottom: 6vw;
`
const BottomText1 = styled.p`
  font-family: YESGothic-Regular;
  font-weight: 700;
  font-size: 5.3vw;
  color: #b8a47a;
`
const BottomB = styled.b`
   font-family: YESGothic-Regular;
    font-weight: 500;
    font-size: 4.2vw;
    color: #5b5b5b;
    font-weight: bold;
  `

const BottomText2 = styled.p`
  font-family: YESGothic-Regular;
  font-weight: 500;
  font-size: 4.2vw;
  color: #5b5b5b;
`